class CountriesData {
  public static countries = [
    {
      code: 'PNG',
      name: 'Papua New Guinea',
    },
    {
      code: 'KHM',
      name: 'Cambodia',
    },
    {
      code: 'N/A',
      name: 'Wales',
    },
    {
      code: 'N/A',
      name: 'England',
    },
    {
      code: 'KAZ',
      name: 'Kazakhstan',
    },
    {
      code: 'PRY',
      name: 'Paraguay',
    },
    {
      code: 'N/A',
      name: 'South Ossetia',
    },
    {
      code: 'SYR',
      name: 'Syria',
    },
    {
      code: 'BHS',
      name: 'Bahamas',
    },
    {
      code: 'SLB',
      name: 'Solomon Islands',
    },
    {
      code: 'MSR',
      name: 'Montserrat',
    },
    {
      code: 'MLI',
      name: 'Mali',
    },
    {
      code: 'MHL',
      name: 'Marshall Islands',
    },
    {
      code: 'GLP',
      name: 'Guadeloupe',
    },
    {
      code: 'PAN',
      name: 'Panama',
    },
    {
      code: 'N/A',
      name: 'Czechoslovakia',
    },
    {
      code: 'LAO',
      name: 'Laos',
    },
    {
      code: 'ARG',
      name: 'Argentina',
    },
    {
      code: 'FLK',
      name: 'Falkland Islands',
    },
    {
      code: 'N/A',
      name: 'Somaliland',
    },
    {
      code: 'SYC',
      name: 'Seychelles',
    },
    {
      code: 'BLZ',
      name: 'Belize',
    },
    {
      code: 'ZMB',
      name: 'Zambia',
    },
    {
      code: 'BHR',
      name: 'Bahrain',
    },
    {
      code: 'N/A',
      name: 'Congo',
    },
    {
      code: 'GNB',
      name: 'Guinea-Bissau',
    },
    {
      code: 'NAM',
      name: 'Namibia',
    },
    {
      code: 'COM',
      name: 'Comoros',
    },
    {
      code: 'FRO',
      name: 'Faroe Islands',
    },
    {
      code: 'FIN',
      name: 'Finland',
    },
    {
      code: 'MKD',
      name: 'North Macedonia',
    },
    {
      code: 'N/A',
      name: 'Netherlands Antilles',
    },
    {
      code: 'GEO',
      name: 'Georgia',
    },
    {
      code: 'N/A',
      name: 'Saint Kitts and Nevis',
    },
    {
      code: 'YEM',
      name: 'Yemen',
    },
    {
      code: 'ERI',
      name: 'Eritrea',
    },
    {
      code: 'PRI',
      name: 'Puerto Rico',
    },
    {
      code: 'ABW',
      name: 'Aruba',
    },
    {
      code: 'MDG',
      name: 'Madagascar',
    },
    {
      code: 'LBY',
      name: 'Libya',
    },
    {
      code: 'SXM',
      name: 'Saint Martin',
    },
    {
      code: 'SWE',
      name: 'Sweden',
    },
    {
      code: 'CCK',
      name: 'Cocos (Keeling) Islands',
    },
    {
      code: 'MWI',
      name: 'Malawi',
    },
    {
      code: 'AND',
      name: 'Andorra',
    },
    {
      code: 'LIE',
      name: 'Liechtenstein',
    },
    {
      code: 'POL',
      name: 'Poland',
    },
    {
      code: 'N/A',
      name: 'United States Virgin Islands',
    },
    {
      code: 'BGR',
      name: 'Bulgaria',
    },
    {
      code: 'JOR',
      name: 'Jordan',
    },
    {
      code: 'TUN',
      name: 'Tunisia',
    },
    {
      code: 'N/A',
      name: 'Turkish Republic of Northern Cyprus',
    },
    {
      code: 'TUV',
      name: 'Tuvalu',
    },
    {
      code: 'ARE',
      name: 'United Arab Emirates',
    },
    {
      code: 'KEN',
      name: 'Kenya',
    },
    {
      code: 'PYF',
      name: 'French Polynesia',
    },
    {
      code: 'BRN',
      name: 'Brunei',
    },
    {
      code: 'DJI',
      name: 'Djibouti',
    },
    {
      code: 'LBN',
      name: 'Lebanon',
    },
    {
      code: 'AZE',
      name: 'Azerbaijan',
    },
    {
      code: 'CUB',
      name: 'Cuba',
    },
    {
      code: 'CZE',
      name: 'Czech Republic',
    },
    {
      code: 'MRT',
      name: 'Mauritania',
    },
    {
      code: 'N/A',
      name: 'Saint Lucia',
    },
    {
      code: 'GGY',
      name: 'Guernsey',
    },
    {
      code: 'MYT',
      name: 'Mayotte',
    },
    {
      code: 'ISR',
      name: 'Israel',
    },
    {
      code: 'SMR',
      name: 'San Marino',
    },
    {
      code: 'AUS',
      name: 'Australia',
    },
    {
      code: 'BES',
      name: 'Bonaire',
    },
    {
      code: 'N/A',
      name: 'Soviet Union',
    },
    {
      code: 'TJK',
      name: 'Tajikistan',
    },
    {
      code: 'N/A',
      name: 'Myanmar',
    },
    {
      code: 'CMR',
      name: 'Cameroon',
    },
    {
      code: 'GIB',
      name: 'Gibraltar',
    },
    {
      code: 'CYP',
      name: 'Cyprus',
    },
    {
      code: 'MNP',
      name: 'Northern Mariana Islands',
    },
    {
      code: 'MYS',
      name: 'Malaysia',
    },
    {
      code: 'ISL',
      name: 'Iceland',
    },
    {
      code: 'OMN',
      name: 'Oman',
    },
    {
      code: 'N/A',
      name: 'Transnistria',
    },
    {
      code: 'ARM',
      name: 'Armenia',
    },
    {
      code: 'GAB',
      name: 'Gabon',
    },
    {
      code: 'N/A',
      name: 'Yugoslavia',
    },
    {
      code: 'LUX',
      name: 'Luxembourg',
    },
    {
      code: 'BRA',
      name: 'Brazil',
    },
    {
      code: 'DZA',
      name: 'Algeria',
    },
    {
      code: 'JEY',
      name: 'Jersey',
    },
    {
      code: 'SVN',
      name: 'Slovenia',
    },
    {
      code: 'N/A',
      name: 'Republic of the Congo',
    },
    {
      code: 'N/A',
      name: 'Antigua and Barbuda',
    },
    {
      code: 'COL',
      name: 'Colombia',
    },
    {
      code: 'ECU',
      name: 'Ecuador',
    },
    {
      code: 'MDA',
      name: 'Moldova',
    },
    {
      code: 'VUT',
      name: 'Vanuatu',
    },
    {
      code: 'SWZ',
      name: 'Eswatini',
    },
    {
      code: 'HND',
      name: 'Honduras',
    },
    {
      code: 'ITA',
      name: 'Italy',
    },
    {
      code: 'NRU',
      name: 'Nauru',
    },
    {
      code: 'HTI',
      name: 'Haiti',
    },
    {
      code: 'AFG',
      name: 'Afghanistan',
    },
    {
      code: 'BDI',
      name: 'Burundi',
    },
    {
      code: 'SGP',
      name: 'Singapore',
    },
    {
      code: 'GUF',
      name: 'French Guiana',
    },
    {
      code: 'ASM',
      name: 'American Samoa',
    },
    {
      code: 'CXR',
      name: 'Christmas Island',
    },
    {
      code: 'N/A',
      name: 'Scotland',
    },
    {
      code: 'TKL',
      name: 'Tokelau Islands',
    },
    {
      code: 'VAT',
      name: 'Vatican City',
    },
    {
      code: 'RUS',
      name: 'Russia',
    },
    {
      code: 'NLD',
      name: 'Netherlands',
    },
    {
      code: 'CHN',
      name: 'China',
    },
    {
      code: 'MTQ',
      name: 'Martinique',
    },
    {
      code: 'N/A',
      name: 'Saint Pierre and Miquelon',
    },
    {
      code: 'KGZ',
      name: 'Kyrgyzstan',
    },
    {
      code: 'N/A',
      name: 'French Southern and Antarctic Lands',
    },
    {
      code: 'N/A',
      name: 'Korea',
    },
    {
      code: 'REU',
      name: 'Reunion',
    },
    {
      code: 'BTN',
      name: 'Bhutan',
    },
    {
      code: 'ROU',
      name: 'Romania',
    },
    {
      code: 'TGO',
      name: 'Togo',
    },
    {
      code: 'IRN',
      name: 'Persia',
    },
    {
      code: 'PHL',
      name: 'Philippines',
    },
    {
      code: 'UZB',
      name: 'Uzbekistan',
    },
    {
      code: 'VGB',
      name: 'British Virgin Islands',
    },
    {
      code: 'ZWE',
      name: 'Zimbabwe',
    },
    {
      code: 'MNE',
      name: 'Montenegro',
    },
    {
      code: 'DMA',
      name: 'Dominica',
    },
    {
      code: 'IDN',
      name: 'Indonesia',
    },
    {
      code: 'BEN',
      name: 'Benin',
    },
    {
      code: 'AGO',
      name: 'Angola',
    },
    {
      code: 'TLS',
      name: 'East Timor',
    },
    {
      code: 'SDN',
      name: 'Sudan',
    },
    {
      code: 'PRT',
      name: 'Portugal',
    },
    {
      code: 'NCL',
      name: 'New Caledonia',
    },
    {
      code: 'GRD',
      name: 'Grenada',
    },
    {
      code: 'PRK',
      name: 'North Korea',
    },
    {
      code: 'CYM',
      name: 'Cayman Islands',
    },
    {
      code: 'GRC',
      name: 'Greece',
    },
    {
      code: 'LVA',
      name: 'Latvia',
    },
    {
      code: 'MNG',
      name: 'Mongolia',
    },
    {
      code: 'IRN',
      name: 'Iran',
    },
    {
      code: 'MAR',
      name: 'Morocco',
    },
    {
      code: 'GTM',
      name: 'Guatemala',
    },
    {
      code: 'GUY',
      name: 'Guyana',
    },
    {
      code: 'IRQ',
      name: 'Iraq',
    },
    {
      code: 'CHL',
      name: 'Chile',
    },
    {
      code: 'NPL',
      name: 'Nepal',
    },
    {
      code: 'GMB',
      name: 'The Gambia',
    },
    {
      code: 'N/A',
      name: 'Catalonia',
    },
    {
      code: 'IMN',
      name: 'Isle of Man',
    },
    {
      code: 'TZA',
      name: 'Tanzania',
    },
    {
      code: 'UKR',
      name: 'Ukraine',
    },
    {
      code: 'CUW',
      name: 'Curaçao',
    },
    {
      code: 'GHA',
      name: 'Ghana',
    },
    {
      code: 'N/A',
      name: 'Holy See',
    },
    {
      code: 'AIA',
      name: 'Anguilla',
    },
    {
      code: 'N/A',
      name: 'Northern Ireland',
    },
    {
      code: 'IND',
      name: 'India',
    },
    {
      code: 'CAN',
      name: 'Canada',
    },
    {
      code: 'MDV',
      name: 'Maldives',
    },
    {
      code: 'TUR',
      name: 'Turkey',
    },
    {
      code: 'BEL',
      name: 'Belgium',
    },
    {
      code: 'MCO',
      name: 'Principality of Monaco',
    },
    {
      code: 'TWN',
      name: 'Taiwan',
    },
    {
      code: 'N/A',
      name: "Ivory Coast (Côte d'Ivoire)",
    },
    {
      code: 'N/A',
      name: 'South Georgia and South Sandwich Islands',
    },
    {
      code: 'ZAF',
      name: 'South Africa',
    },
    {
      code: 'N/A',
      name: 'Trinidad and Tobago',
    },
    {
      code: 'BMU',
      name: 'Bermuda',
    },
    {
      code: 'N/A',
      name: 'Aland Islands',
    },
    {
      code: 'CAF',
      name: 'Central African Republic',
    },
    {
      code: 'N/A',
      name: 'Democratic Republic of the Congo',
    },
    {
      code: 'JAM',
      name: 'Jamaica',
    },
    {
      code: 'PER',
      name: 'Peru',
    },
    {
      code: 'TKM',
      name: 'Turkmenistan',
    },
    {
      code: 'DEU',
      name: 'Germany',
    },
    {
      code: 'FJI',
      name: 'Fiji',
    },
    {
      code: 'N/A',
      name: 'Hong Kong',
    },
    {
      code: 'GIN',
      name: 'Guinea',
    },
    {
      code: 'TCD',
      name: 'Chad',
    },
    {
      code: 'SOM',
      name: 'Somalia',
    },
    {
      code: 'PCN',
      name: 'Pitcairn Islands',
    },
    {
      code: 'THA',
      name: 'Thailand',
    },
    {
      code: 'N/A',
      name: 'United Kingdom of Great Britain and Northern Ireland',
    },
    {
      code: 'GNQ',
      name: 'Equatorial Guinea',
    },
    {
      code: 'KIR',
      name: 'Kiribati',
    },
    {
      code: 'CRI',
      name: 'Costa Rica',
    },
    {
      code: 'VNM',
      name: 'Vietnam',
    },
    {
      code: 'N/A',
      name: 'São Tomé and Príncipe',
    },
    {
      code: 'KWT',
      name: 'Kuwait',
    },
    {
      code: 'NGA',
      name: 'Nigeria',
    },
    {
      code: 'HRV',
      name: 'Croatia',
    },
    {
      code: 'COK',
      name: 'Cook Islands',
    },
    {
      code: 'LKA',
      name: 'Sri Lanka',
    },
    {
      code: 'URY',
      name: 'Uruguay',
    },
    {
      code: 'TLS',
      name: 'Timor-Leste',
    },
    {
      code: 'GBR',
      name: 'United Kingdom',
    },
    {
      code: 'CHE',
      name: 'Switzerland',
    },
    {
      code: 'WSM',
      name: 'Samoa',
    },
    {
      code: 'N/A',
      name: 'Palestine',
    },
    {
      code: 'ESP',
      name: 'Spain',
    },
    {
      code: 'LBR',
      name: 'Liberia',
    },
    {
      code: 'VEN',
      name: 'Venezuela',
    },
    {
      code: 'BFA',
      name: 'Burkina Faso',
    },
    {
      code: 'PLW',
      name: 'Palau',
    },
    {
      code: 'BLM',
      name: 'Saint Barthélemy',
    },
    {
      code: 'EST',
      name: 'Estonia',
    },
    {
      code: 'N/A',
      name: 'Lower Austria',
    },
    {
      code: 'N/A',
      name: 'Wallis and Futuna',
    },
    {
      code: 'NIU',
      name: 'Niue',
    },
    {
      code: 'AUT',
      name: 'Austria',
    },
    {
      code: 'KOR',
      name: 'South Korea',
    },
    {
      code: 'MOZ',
      name: 'Mozambique',
    },
    {
      code: 'SLV',
      name: 'El Salvador',
    },
    {
      code: 'MCO',
      name: 'Monaco',
    },
    {
      code: 'GUM',
      name: 'Guam',
    },
    {
      code: 'LSO',
      name: 'Lesotho',
    },
    {
      code: 'TON',
      name: 'Tonga',
    },
    {
      code: 'ESH',
      name: 'Western Sahara',
    },
    {
      code: 'N/A',
      name: 'Abkhazia',
    },
    {
      code: 'HUN',
      name: 'Hungary',
    },
    {
      code: 'SSD',
      name: 'South Sudan',
    },
    {
      code: 'JPN',
      name: 'Japan',
    },
    {
      code: 'BLR',
      name: 'Belarus',
    },
    {
      code: 'MUS',
      name: 'Mauritius',
    },
    {
      code: 'N/A',
      name: 'Bouvet Island',
    },
    {
      code: 'ALB',
      name: 'Albania',
    },
    {
      code: 'NFK',
      name: 'Norfolk Island',
    },
    {
      code: 'NZL',
      name: 'New Zealand',
    },
    {
      code: 'TCA',
      name: 'Turks & Caicos Islands',
    },
    {
      code: 'SEN',
      name: 'Senegal',
    },
    {
      code: 'ETH',
      name: 'Ethiopia',
    },
    {
      code: 'USA',
      name: 'United States of America',
    },
    {
      code: 'EGY',
      name: 'Egypt',
    },
    {
      code: 'N/A',
      name: 'Macau',
    },
    {
      code: 'SLE',
      name: 'Sierra Leone',
    },
    {
      code: 'BOL',
      name: 'Bolivia',
    },
    {
      code: 'MLT',
      name: 'Malta',
    },
    {
      code: 'SAU',
      name: 'Saudi Arabia',
    },
    {
      code: 'CPV',
      name: 'Cape Verde',
    },
    {
      code: 'PAK',
      name: 'Pakistan',
    },
    {
      code: 'N/A',
      name: 'Kosovo',
    },
    {
      code: 'IRL',
      name: 'Ireland',
    },
    {
      code: 'QAT',
      name: 'Qatar',
    },
    {
      code: 'SVK',
      name: 'Slovakia',
    },
    {
      code: 'FRA',
      name: 'France',
    },
    {
      code: 'LTU',
      name: 'Lithuania',
    },
    {
      code: 'SRB',
      name: 'Serbia',
    },
    {
      code: 'N/A',
      name: 'Bosnia and Herzegovina',
    },
    {
      code: 'N/A',
      name: 'Holland',
    },
    {
      code: 'NER',
      name: 'Niger',
    },
    {
      code: 'RWA',
      name: 'Rwanda',
    },
    {
      code: 'N/A',
      name: 'Burma',
    },
    {
      code: 'BGD',
      name: 'Bangladesh',
    },
    {
      code: 'BRB',
      name: 'Barbados',
    },
    {
      code: 'NIC',
      name: 'Nicaragua',
    },
    {
      code: 'NOR',
      name: 'Norway',
    },
    {
      code: 'BWA',
      name: 'Botswana',
    },
    {
      code: 'N/A',
      name: 'Saint Vincent and the Grenadines',
    },
    {
      code: 'DNK',
      name: 'Denmark',
    },
    {
      code: 'DOM',
      name: 'Dominican Republic',
    },
    {
      code: 'MEX',
      name: 'Mexico',
    },
    {
      code: 'UGA',
      name: 'Uganda',
    },
    {
      code: 'FSM',
      name: 'Micronesia',
    },
    {
      code: 'SUR',
      name: 'Suriname',
    },
    {
      code: 'GRL',
      name: 'Greenland',
    },
    {
      code: 'SHN',
      name: 'Saint Helena',
    },
  ];
}

export default CountriesData;
